export default __webpack_public_path__ + "static/media/Audo_IMG.57682df6.jpg";